import styled from 'styled-components';
import { px } from '../../../contrib/ui';

export const TeamCardMetadataStyled = styled.div`
  .team-card-header {
    display: flex;
    flex-direction: row;
    align-items: center;

    margin-top: ${px(-10)};
    height: ${px(40)};

    .input-form-control {
      div {
        padding-bottom: 0;
        margin: 0;
      }
    }

    .team-warning {
      display: inline-block;
    }
  }
`;
